<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" 
        
            [routerLink]="['/carInfo',searchModel.get('strUnitID')?.value]">
        
        </i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">
            
            بازرسی ایمنی

        
        </a>

    </div>

</div>

<div dir="rtl" class="main-result p-2">

    <div class="row gx-2 gy-2 gy-md-0  p-2">

        <div class="col-12" [ngClass]="acssess.bFInspection_User_Save ? 'col-md-11' : 'col-md-12' ">

            <input type="text" class="form-control" placeholder="جستجو کنید">

        </div>

        <div class="col-12 col-md-1">

            <button class="btn btn-success w-100" data-bs-toggle="modal"

                *ngIf="acssess.bFInspection_User_Save"
            
                data-bs-target="#Inspection_Modal" (click)="reset_Form_Value()">
                
                افزودن 
        
            </button>

        </div>

    </div>

    <div class="p-3 mt-2 table-responsive overflow-auto" style="height:86vh;">

        <table class="table border border-2 mt-1 table-responsive table-striped overflow-auto">

            <thead class=" ">

                <tr class="text-center">
    
                    <th scope="col" class=""> # </th>

                    <th scope="col" class=""> عملیات </th>

                    <th scope="col" class=""> تاریخ بازرسی </th>
                    
                    <th scope="col" class=""> وضعیت خودرو </th>
    
                </tr>

            </thead>

            <tbody>

                <tr class="text-center  dirI " *ngFor="let item of list_Inspections;let i=index">

                    <th class="text-secondary"> {{ i + 1 | faNum }} </th>

                    <td class="text-secondary">

                        <i class="fa fa-eye fa-lg mx-2 pointer" title=" مشاهده "  (click)="edit_Modal(item,true)"></i>

                        <i class="fa fa-edit fa-lg text-primary mx-2 pointer" 
                        
                            *ngIf="acssess.bFInspection_User_Edit" title=" ویرایش " (click)="edit_Modal(item)">
                        
                        </i>

                        <i class="fa fa-trash fa-lg text-danger mx-2 pointer" 
                        
                            *ngIf="acssess.bFInspection_User_Delete" title=" حذف " (click)="remove_Inspection(item,i)">
                        
                        </i>

                    </td>

                    <td class="text-center">

                        {{ item.strDate | faNum }}

                    </td>

                    <td class="text-center">

                        {{ item.strFirst_FInspection_ResultItem_strComment }}

                    </td>

                </tr>

            </tbody>

        </table>
    
    </div>

</div>

<!-- New Inspections -->

<div class="modal fade rtl " id="Inspection_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true"  data-bs-keyboard="false">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> {{ bViewMode ? ' مشاهده اطلاعات ثبت شده ' :  list_ValueItems.length ? 'ویرایش' : 'ثبت بازرسی ایمنی' }}  </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeAudio_Modal(true)"></button>

            </div>

            <form [formGroup]="inspection_Model" class="modal-body overflow-auto row gx-2 p-3" style="max-height:70vh;">

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" 
                
                    *ngFor="let item of list_Items; let index = index" 
                    
                    class="row gx-1 gy-2 gy-md-0 col-12 p-2 mb-3 justify-content-between align-items-center border border-2">

                    <div class="col-12 col-md-4">

                        <span> {{ '* ' + item.strTitle }} :  </span>

                    </div>

                    <div class="col-12 col-md-4 d-flex justify-content-md-center align-items-center">

                        <ng-container *ngFor="let radio of splitItems(item.strItems); let radioIndex = index">

                            <input type="radio" class="mx-2 pointer" [name]="item.iFInspection_Items"
                                                          
                              (change)="setValue_Radio(index,radio,radioIndex)"> {{ radio }} 

                        </ng-container>

                    </div>

                    <div class="col-12 col-md-4 d-flex justify-content-center align-items-center">

                        <input type="text" class="form-control" placeholder="توضیحات" (change)="setValue_Description(index,$event.target.value)">

                    </div>

                    <!-- uploader handler -->

                    <div *ngIf="item.tiImageRequired != 0 " class="col-12 col-md-4 pt-3">

                        <ng-container *ngIf="!isUploaded(index)">

                            <button class="btn btn-secondary w-100" (click)="fileInput.click()"> 

                                <i class="fa fa-camera me-1" aria-hidden="true"></i>
    
                                <span class="text-warning"> {{ item.tiImageRequired == 1 ? '' : '*' }} </span>
    
                                تصویر ضمیمه
    
                                <span > {{ item.tiImageRequired == 1 ? '( اختیاری )' : '( اجباری )' }} </span>
    
                                <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0],index)"/>
                                
                            </button>

                        </ng-container>

                        <ng-container *ngIf="isUploaded(index)">

                            <div class="w-100 d-flex  border border-2 border-primary rounded" [ngStyle]="{'pointer-events' :'auto' }">

                                <button class="btn btn-primary d-flex justify-content-center align-items-center col-10"

                                    (click)="view_Uploaded(index)"

                                    style="border-radius: 0px;"> 

                                    <i class="fa fa-eye" aria-hidden="true"></i>

                                    <span class="mx-2"> مشاهده تصویر </span>
                                    
                                </button>

                                <div class="audio-icon col-2">
    
                                    <button (click)="clearUploaded(index)">
                                
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                           
                                   </button>
    
                                </div>

                            </div>

                        </ng-container>

                    </div>

                    <!-- audio handler -->

                    <div *ngIf="item.tiVoiceRequired != 0 " class="col-12 col-md-4 pt-3" style="max-height: 71px;">

                        <!-- start Recording -->

                        <ng-container *ngIf="!isAudioRecording && !isAudioRecorded(index)">

                            <button class="btn btn-secondary w-100" (click)="startAudioRecording(item,index)"> 

                                <i class="fa fa-microphone me-1" aria-hidden="true"></i>
    
                                <span class="text-warning"> {{ item.tiVoiceRequired == 1 ? '' : '*' }} </span>
    
                                ضبط صدا
    
                                <span> {{ item.tiVoiceRequired == 1 ? '( اختیاری )' : '( اجباری )' }} </span>
                                
                            </button>

                        </ng-container>

                        <!-- stop Recording -->

                        <ng-container *ngIf="isAudioRecording && !isAudioRecorded(index)" >

                            <button class="btn btn-secondary w-100" (click)="stopAudioRecording()"> 

                                <i class="fa fa-square me-1" aria-hidden="true"></i>
        
                                توقف صدا
    
                                <span> {{ audioRecordedTime | faNum }} </span>
                                
                            </button>

                        </ng-container>

                        <!-- play Recording -->

                        <ng-container *ngIf="!isAudioRecording && isAudioRecorded(index)">

                            <div class="w-100 d-flex  border border-2 border-primary rounded" [ngStyle]="{'pointer-events' :'auto' }">

                                <button class="btn btn-primary d-flex justify-content-center align-items-center col-10"

                                    (click)="playAudio(index)"
                                
                                    style="border-radius: 0px;"> 

                                    <i class="fa fa-play" aria-hidden="true"></i>

                                    <span class="mx-2"> پخش صدا </span>
                                    
                                </button>

                                <div class="audio-icon col-2" *ngIf="isAudioRecorded(index)">
    
                                    <button (click)="clearAudioRecordedData(item)">
                                
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                           
                                   </button>
    
                                </div>

                            </div>

                        </ng-container>

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" 
                
                    class="d-flex flex-column align-items-start justify-content-center border border-2 p-2 mb-3">

                    <div class="d-flex align-items-center" *ngFor="let item of list_ResultItems; let index = index">

                        <input type="checkbox" [disabled]="isCheckboxDisabled(item,checkbox.checked)"

                            [title]="isCheckboxDisabled(item,checkbox.checked) == true ? 'یک مورد انتخاب شده است' : '' "
                        
                            #checkbox (click)="setValue_ResultItem(item,checkbox.checked)"> 

                        <span class="mx-2"> {{ item.strComment }} </span>

                    </div>

                    <div class="date-container" *ngIf="inspection_Model.get('tiFirst_FInspection_ResultItem')?.value == 1" class="mt-2">

                        <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false" 
                        
                            [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" class="form-control" formControlName="strDeadlineDate" 
                            
                                placeholder="* تاریخ مهلت رفع عیوب"/>

                        </ng-persian-datepicker>

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" 
                
                    *ngIf="list_ValueItems.length && false" 
                    
                    class="d-flex flex-column align-items-start justify-content-center border border-2 p-2 mb-3">

                    <div class="d-flex align-items-center" *ngFor="let item of list_ResultItems_Review; let index = index">

                        <input type="checkbox" [disabled]="isCheckboxDisabled_Review(item,checkbox.checked)"

                            [title]="isCheckboxDisabled_Review(item,checkbox.checked) == true ? 'یک مورد انتخاب شده است' : '' "
                        
                            #checkbox (click)="setValue_ResultItem_Review(item,checkbox.checked)"> 

                        <span class="mx-2"> {{ item.strComment }} </span>

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" 
                
                    class="d-flex flex-column align-items-start justify-content-center border border-2 p-2">

                    <div class="d-flex align-items-center">

                        <input type="checkbox" formControlName="bThirdInsurance"> 

                        <span class="mx-2">  بیمه شخص ثالث </span>

                    </div>

                    <div class="d-flex align-items-center">

                        <input type="checkbox" formControlName="bBodyinsurance"> 

                        <span class="mx-2">  بیمه بدنه </span>

                    </div>

                    <div class="date-container" *ngIf="inspection_Model.get('bThirdInsurance')?.value || inspection_Model.get('bBodyinsurance')?.value" class="mt-2">

                        <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false"
                        
                            [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" class="form-control" formControlName="strInsuranceValidityDate"
                            
                                placeholder="* مدت اعتبار بیمه نامه"/>

                        </ng-persian-datepicker>

                    </div>

                </div>

                <div [ngStyle]="{'pointer-events' : bViewMode ? 'none' : 'auto' }" 
                
                    class="row gx-1 gy-2 gy-md-0 pb-3 border border-2 mt-3">

                    <div class="col-12 col-md-6 d-md-flex align-items-center justify-content-center mt-3">

                        <div class="col-12 col-md-4">

                            <span class="col-12 col-md-6"> * نام بازرس تجهیزات :  </span>
                                                        
                        </div>

                        <div class="col-12 col-md-7 mt-2 mt-md-0">

                            <input type="text" class="form-control col-12 col-md-6" formControlName="strEquipmentInspector">                        
                            
                        </div>
                        
                    </div>

                    <div class="col-12 col-md-6 d-md-flex align-items-center justify-content-center mt-3">

                        <div class="col-12 col-md-4">

                            <span class="col-12 col-md-6"> * نام بازرس ایمنی :  </span>
                                                        
                        </div>

                        <div class="col-12 col-md-7 mt-2 mt-md-0">

                            <input type="text" class="form-control col-12 col-md-6" formControlName="strSafetyInspector">                        
                            
                        </div>
                        
                    </div>

                    <div class="col-12 mt-3 px-2 pe-md-4">

                        <textarea class="form-control" 
                        
                            style="height: 120px; max-height: 120px;resize: none;"
                            
                            placeholder="توضیحات خود را وارد کنید" formControlName="strComment">
                        
                        </textarea>

                    </div>
    
                </div>

                <div *ngIf="!bViewMode" class="col-12 d-flex mt-2">

                    <div class="col-12 col-md-2">

                        <button [ngClass]="list_ValueItems.length ? 'btn-primary' : 'btn-success' " class="w-100 btn" (click)="submit_Inspection()">
                            
                             {{ list_ValueItems.length ? 'ویرایش' : 'ذخیره' }}
                        
                        </button>

                    </div>

                </div>

            </form>
        
            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>

<!-- listen to Recorded audio -->

<div class="modal fade rtl" id="play_audio" data-backdrop="false" data-bs-backdrop='static' tabindex="-1" aria-labelledby="" aria-hidden="true" data-bs-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-sm">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> پخش صدا </h5>

                <button type="button" class="btn-close" (click)="closeAudio_Modal()"></button>

            </div>

            <div  class="modal-body" *ngIf="audioSrcUrl != ''">

                <audio controls class="w-100 rounded" style="background:#F1F3F4 ;">

                    <source [src]="audioSrcUrl" type="audio/mp3">

                    Your browser does not support the audio element.

                </audio>

            </div>

            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>

<!-- show Uploaded file -->

<div class="modal fade rtl" id="view_Uploaded" data-backdrop="false" data-bs-backdrop='static' tabindex="-1" aria-labelledby="" aria-hidden="true" data-bs-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-sm">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> مشاهده تصویر </h5>

                <button type="button" class="btn-close" (click)="closeAudio_Modal()"></button>

            </div>

            <div  class="modal-body" *ngIf="SRC_IMAGE">

                <img class="request-img border border-2 rounded p-2 pointer"
                    
                width="100%" style="max-height: 360px;object-fit: contain;"
                
                src="{{SRC_IMAGE}}"
                    
                id="fullScreen_" (click)="fullScreen_Image()" >

            </div>

            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>